(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-glp1-howitworks"] && !Shopify.designMode) return;
  try {
    
  class Glp1HiwSteps extends HTMLElement {
    connectedCallback() {
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.steps = Array.from(this.querySelectorAll('.glp1-hiw__step')).map(function (el) {
        return {
          el: el,
          bar: el.querySelector('.glp1-hiw__step-bar'),
          title: el.querySelector('.glp1-hiw__step-text strong'),
          body: el.querySelector('.glp1-hiw__step-body'),
          current: 0
        };
      });
      this.lastTime = null;

      this.syncTitleWidths = this.syncTitleWidths.bind(this);
      this.syncTitleWidths();
      window.addEventListener('resize', this.syncTitleWidths);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this.syncTitleWidths);
      }

      if (this.reduceMotion) {
        this.steps.forEach(function (step) {
          step.bar.style.opacity = '1';
          step.title.style.opacity = '1';
          step.body.style.opacity = '1';
          step.body.style.maxHeight = step.body.scrollHeight + 'px';
          step.body.style.marginTop = '8px';
        });
        return;
      }

      this.loop = this.loop.bind(this);
      this.raf = requestAnimationFrame(this.loop);
    }

    syncTitleWidths() {
      this.steps.forEach(function (step) {
        step.body.style.maxWidth = step.title.getBoundingClientRect().width + 'px';
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.syncTitleWidths);
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    loop(timestamp) {
      var vh = window.innerHeight;
      var isMobile = window.innerWidth <= 768;

      if (this.lastTime == null) this.lastTime = timestamp;
      var dt = (timestamp - this.lastTime) / 1000;
      this.lastTime = timestamp;
      dt = Math.max(0, Math.min(dt, 0.1));

      var baseSmoothing = 0.12;
      var smoothing = 1 - Math.pow(1 - baseSmoothing, dt * 60);

      this.steps.forEach(function (step, index) {
        var rect = step.el.getBoundingClientRect();
        var offset = (index + 1) * (isMobile ? 130 : 140);
        var startTop = vh * 0.95 - offset;
        var elementHeight = rect.height || 40;
        var startBottom = startTop + elementHeight;
        var endBottom = vh * 0.5;
        var scrollRange = startBottom - endBottom;
        var target;
        if (scrollRange <= 0) {
          target = (rect.top + offset <= vh * 0.95) ? 1 : 0;
        } else {
          target = (startBottom - rect.bottom) / scrollRange;
        }
        target = Math.max(0, Math.min(1, target));

        step.current += (target - step.current) * smoothing;
        if (Math.abs(target - step.current) < 0.001) step.current = target;
        step.current = Math.max(0, Math.min(1, step.current));

        var dimOpacity = 0.4 + 0.6 * step.current;
        step.bar.style.opacity = dimOpacity;
        step.title.style.opacity = dimOpacity;
        step.body.style.opacity = dimOpacity;

        var naturalHeight = step.body.scrollHeight || step.body.offsetHeight;
        step.body.style.maxHeight = (naturalHeight * step.current) + 'px';
        step.body.style.marginTop = (8 * step.current) + 'px';
      });

      this.raf = requestAnimationFrame(this.loop);
    }
  }

  if (!customElements.get('hl-glp1-hiw-steps')) {
    customElements.define('hl-glp1-hiw-steps', Glp1HiwSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-glp1-main"] && !Shopify.designMode) return;
  try {
    
  class Glp1Main extends HTMLElement {
    connectedCallback() {
      var root = this;

      if (!window.glp1ReloadScrollFixed && window.performance && performance.getEntriesByType) {
        window.glp1ReloadScrollFixed = true;
        var navEntry = performance.getEntriesByType('navigation')[0];
        if (navEntry && navEntry.type === 'reload') {
          if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
          window.scrollTo(0, 0);
        }
      }

      var slides = root.querySelectorAll('.glp1-gallery__slide');
      var thumbs = root.querySelectorAll('.glp1-gallery__thumb');
      var mainEl = root.querySelector('.glp1-gallery__main');
      var prevArrow = root.querySelector('.glp1-gallery__arrow--prev');
      var nextArrow = root.querySelector('.glp1-gallery__arrow--next');
      var mobileQuery = window.matchMedia('(max-width: 989px)');

      function setActiveClasses(index) {
        slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.slide === String(index)); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.slide === String(index)); });
      }

      function activate(index) {
        setActiveClasses(index);
        if (mobileQuery.matches && mainEl) {
          var target = mainEl.querySelector('.glp1-gallery__slide[data-slide="' + index + '"]');
          if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { activate(t.dataset.slide); });
      });

      function currentIndex() {
        var activeThumb = root.querySelector('.glp1-gallery__thumb.is-active') || root.querySelector('.glp1-gallery__slide.is-active');
        return parseInt(activeThumb ? activeThumb.dataset.slide : '0', 10) || 0;
      }

      function shiftSlide(dir) {
        var count = slides.length;
        if (!count) return;
        var next = (currentIndex() + dir + count) % count;
        activate(String(next));
      }

      if (prevArrow) prevArrow.addEventListener('click', function () { shiftSlide(-1); });
      if (nextArrow) nextArrow.addEventListener('click', function () { shiftSlide(1); });

      if (mainEl) {
        var scrollTimer;
        function syncFromScroll() {
          if (!mobileQuery.matches) return;
          var width = mainEl.clientWidth;
          if (!width) return;
          var idx = Math.round(mainEl.scrollLeft / width);
          setActiveClasses(idx);
        }
        mainEl.addEventListener('scroll', function () {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(syncFromScroll, 100);
        }, { passive: true });
        mainEl.addEventListener('scrollend', syncFromScroll, { passive: true });
      }

      /* Custom plan card ↔ RecurPay bridge.
         RecurPay injects a hidden widget with two radios (.recurpay__subscribe_radio /
         .recurpay__onetime_radio) that own the form's selling_plan + line-item props.
         Our visible card just mirrors the chosen option onto RecurPay's radio, so the
         real RecurPay selling_plan is attached (subscribe) or cleared (one-time) and a
         genuine subscription starts on Add to Cart. */
      var planChoiceInputs = root.querySelectorAll('input[name="glp1_plan_choice"]');
      var qtyInput = root.querySelector('[data-glp1-qty]');

      /* Subscribe = a 3-pack bundle (a Shopify automatic discount makes it buy-2-get-1-free),
         one-time = a single unit. Set the cart quantity to match the chosen option. */
      function setQty(plan) {
        if (qtyInput) {
          var subQty = qtyInput.getAttribute('data-sub-qty') || '3';
          qtyInput.value = plan === 'onetime' ? '1' : subQty;
        }
      }

      function findRecurRadio(plan) {
        return plan === 'onetime'
          ? root.querySelector('.recurpay__onetime_radio')
          : root.querySelector('.recurpay__subscribe_radio');
      }

      function syncToRecurPay(plan) {
        var radio = findRecurRadio(plan);
        if (!radio) return false;
        if (!radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          radio.dispatchEvent(new Event('click', { bubbles: true }));
        }
        return true;
      }

      planChoiceInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          if (input.checked) {
            setQty(input.dataset.plan);
            syncToRecurPay(input.dataset.plan);
          }
        });
      });

      /* RecurPay injects asynchronously — retry the initial sync until it exists. */
      (function initRecurSync() {
        var checked = root.querySelector('input[name="glp1_plan_choice"]:checked');
        var plan = checked ? checked.dataset.plan : 'subscribe';
        setQty(plan);
        var tries = 0;
        var iv = setInterval(function () {
          tries += 1;
          if (syncToRecurPay(plan) || tries > 40) clearInterval(iv);
        }, 250);
      })();

      var zoomBtn = root.querySelector('.glp1-gallery__zoom');
      var lightbox = root.querySelector('.glp1-gallery__lightbox');
      var lightboxImg = lightbox ? lightbox.querySelector('img') : null;
      var lightboxClose = root.querySelector('.glp1-gallery__lightbox-close');
      if (zoomBtn && lightbox && lightboxImg) {
        zoomBtn.addEventListener('click', function () {
          var active = root.querySelector('.glp1-gallery__slide.is-active');
          if (active && active.tagName === 'IMG') lightboxImg.src = active.src;
          lightbox.hidden = false;
        });
        lightboxClose.addEventListener('click', function () { lightbox.hidden = true; });
        lightbox.addEventListener('click', function (e) {
          if (e.target === lightbox) lightbox.hidden = true;
        });
      }

      var factsBtn = root.querySelector('.glp1-buybox__facts-trigger');
      var factsLightbox = root.querySelector('.glp1-buybox__facts-lightbox');
      var factsClose = root.querySelector('.glp1-buybox__facts-close');
      if (factsBtn && factsLightbox) {
        factsBtn.addEventListener('click', function () { factsLightbox.hidden = false; });
        if (factsClose) factsClose.addEventListener('click', function () { factsLightbox.hidden = true; });
        factsLightbox.addEventListener('click', function (e) {
          if (e.target === factsLightbox) factsLightbox.hidden = true;
        });
      }

      var atcAnchor = root.querySelector('[data-atc-anchor]');
      var stickybar = root.querySelector('glp1-stickybar');
      if (atcAnchor && stickybar) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            stickybar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        }, { threshold: 0 });
        observer.observe(atcAnchor);
      }

      var stickyAtc = root.querySelector('[data-sticky-atc]');
      if (stickyAtc && atcAnchor) {
        stickyAtc.addEventListener('click', function () {
          atcAnchor.click();
        });
      }
    }
  }

  if (!customElements.get('hl-glp1-main')) {
    customElements.define('hl-glp1-main', Glp1Main);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-glp1-reviewgallery"] && !Shopify.designMode) return;
  try {
    
  class HlGlp1Marquee extends HTMLElement {
    connectedCallback() {
      this.originals = Array.from(this.children);
      if (!this.originals.length) return;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.build();
      this.resizeObserver = new ResizeObserver(() => this.debounceBuild());
      this.resizeObserver.observe(this.closest('.hl-rg__viewport'));
      this.setupTouchHold();
    }

    setupTouchHold() {
      // Touch devices have no real hover, so the `:hover` pause (gated to
      // `@media (hover: hover)` in CSS, deliberately excluding touch-only
      // devices) never applies here — some mobile browsers otherwise get
      // stuck in a simulated `:hover` state after a tap with no mouse to
      // ever "unhover" it, permanently pausing the scroll. A real
      // press-and-hold should still pause it though: touchstart pauses,
      // but touchmove (the finger is actually scrolling the page, not
      // holding still) resumes it immediately so a normal scroll-past
      // barely interrupts the animation.
      const pause = () => this.classList.add('is-touch-paused');
      const resume = () => this.classList.remove('is-touch-paused');
      this.addEventListener('touchstart', pause, { passive: true });
      this.addEventListener('touchmove', resume, { passive: true });
      this.addEventListener('touchend', resume, { passive: true });
      this.addEventListener('touchcancel', resume, { passive: true });
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
    }

    debounceBuild() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.build(), 150);
    }

    build() {
      this.innerHTML = '';
      this.originals.forEach((el) => this.appendChild(el.cloneNode(true)));
      this.classList.remove('hl-rg__track--animating');
      this.style.removeProperty('--hl-rg-distance');
      this.style.removeProperty('animation-duration');

      const viewport = this.closest('.hl-rg__viewport');
      if (!viewport || this.reduceMotion) return;

      const targetWidth = viewport.offsetWidth * 2;
      let guard = 0;
      // Always append at least one extra full set: if the original tiles
      // alone already exceed targetWidth (narrow viewport, few tiles, or
      // just wide tiles), the width check below never becomes true and
      // this loop used to never run at all — leaving only one set of
      // tiles with no "repeat" set to loop back into. `children[originals
      // .length]` (firstRepeatChild) would then be undefined and build()
      // returned early without ever activating the scroll animation.
      do {
        this.originals.forEach((el) => this.appendChild(el.cloneNode(true)));
        guard += 1;
      } while (this.scrollWidth < targetWidth && guard < 20);

      const firstRepeatChild = this.children[this.originals.length];
      if (!firstRepeatChild) return;

      const distance = firstRepeatChild.offsetLeft - this.children[0].offsetLeft;
      if (!distance) return;

      const pxPerSecond = 42;
      const duration = distance / pxPerSecond;

      this.style.setProperty('--hl-rg-distance', `-${distance}px`);
      this.style.animationDuration = `${duration}s`;
      this.classList.add('hl-rg__track--animating');

      Array.from(this.children)
        .slice(this.originals.length)
        .forEach((el) => el.setAttribute('aria-hidden', 'true'));
    }
  }

  if (!customElements.get('hl-glp1-marquee')) {
    customElements.define('hl-glp1-marquee', HlGlp1Marquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-glp1-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var btn = document.querySelector('.glp1-rev__write-btn');
    if (btn && !btn.dataset.glp1WriteBound) {
      btn.dataset.glp1WriteBound = 'true';
      btn.addEventListener('click', function () {
        var footer = document.querySelector('footer, .glp1-ft') || document.body;
        var targetY = footer.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: targetY, behavior: 'smooth' });
        setTimeout(function () {
          if (Math.abs(window.scrollY - targetY) > 40) {
            window.scrollTo(0, targetY);
          }
        }, 600);
      });
    }

    var moreBtn = document.querySelector('.glp1-rev__more');
    var cards = document.querySelectorAll('.glp1-rev__card');
    if (moreBtn && cards.length && !moreBtn.dataset.glp1MoreBound) {
      moreBtn.dataset.glp1MoreBound = 'true';
      var maxBatch = 0;
      cards.forEach(function (c) {
        var b = parseInt(c.dataset.batch, 10) || 0;
        if (b > maxBatch) maxBatch = b;
      });
      var currentBatch = 0;
      if (maxBatch === 0) {
        moreBtn.hidden = true;
      }
      moreBtn.addEventListener('click', function () {
        currentBatch += 1;
        cards.forEach(function (c) {
          if (parseInt(c.dataset.batch, 10) === currentBatch) c.classList.remove('glp1-rev__card--hidden');
        });
        if (currentBatch >= maxBatch) moreBtn.hidden = true;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-glp1-survey"] && !Shopify.designMode) return;
  try {
    
  class Glp1SurveyStats extends HTMLElement {
    connectedCallback() {
      var stats = this.querySelectorAll('.glp1-survey__stat');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var fill = el.querySelector('.glp1-survey__stat-fill');
          fill.style.setProperty('--target-width', fill.dataset.targetPercent + '%');
          el.classList.add('is-visible');
          var counter = el.querySelector('[data-count-to]');
          var target = parseInt(counter.dataset.countTo, 10);
          var start = null;
          var duration = 900;
          function step(ts) {
            if (!start) start = ts;
            var progress = Math.min((ts - start) / duration, 1);
            counter.textContent = Math.round(progress * target);
            if (progress < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
          observer.unobserve(el);
        });
      }, { threshold: 0.4 });
      stats.forEach(function (s) { observer.observe(s); });
    }
  }

  if (!customElements.get('hl-glp1-survey-stats')) {
    customElements.define('hl-glp1-survey-stats', Glp1SurveyStats);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-hbh-howitworks"] && !Shopify.designMode) return;
  try {
    
  class HbhHiwSteps extends HTMLElement {
    connectedCallback() {
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.steps = Array.from(this.querySelectorAll('.hbh-hiw__step')).map(function (el) {
        return {
          el: el,
          bar: el.querySelector('.hbh-hiw__step-bar'),
          title: el.querySelector('.hbh-hiw__step-text strong'),
          body: el.querySelector('.hbh-hiw__step-body'),
          current: 0
        };
      });
      this.lastTime = null;

      this.syncTitleWidths = this.syncTitleWidths.bind(this);
      this.syncTitleWidths();
      window.addEventListener('resize', this.syncTitleWidths);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this.syncTitleWidths);
      }

      if (this.reduceMotion) {
        this.steps.forEach(function (step) {
          step.bar.style.opacity = '1';
          step.title.style.opacity = '1';
          step.body.style.opacity = '1';
          step.body.style.maxHeight = step.body.scrollHeight + 'px';
          step.body.style.marginTop = '8px';
        });
        return;
      }

      this.loop = this.loop.bind(this);
      this.raf = requestAnimationFrame(this.loop);
    }

    syncTitleWidths() {
      this.steps.forEach(function (step) {
        step.body.style.maxWidth = step.title.getBoundingClientRect().width + 'px';
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.syncTitleWidths);
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    loop(timestamp) {
      var vh = window.innerHeight;
      var isMobile = window.innerWidth <= 768;

      if (this.lastTime == null) this.lastTime = timestamp;
      var dt = (timestamp - this.lastTime) / 1000;
      this.lastTime = timestamp;
      dt = Math.max(0, Math.min(dt, 0.1));

      var baseSmoothing = 0.12;
      var smoothing = 1 - Math.pow(1 - baseSmoothing, dt * 60);

      this.steps.forEach(function (step, index) {
        var rect = step.el.getBoundingClientRect();
        var offset = (index + 1) * (isMobile ? 130 : 140);
        var startTop = vh * 0.95 - offset;
        var elementHeight = rect.height || 40;
        var startBottom = startTop + elementHeight;
        var endBottom = vh * 0.5;
        var scrollRange = startBottom - endBottom;
        var target;
        if (scrollRange <= 0) {
          target = (rect.top + offset <= vh * 0.95) ? 1 : 0;
        } else {
          target = (startBottom - rect.bottom) / scrollRange;
        }
        target = Math.max(0, Math.min(1, target));

        step.current += (target - step.current) * smoothing;
        if (Math.abs(target - step.current) < 0.001) step.current = target;
        step.current = Math.max(0, Math.min(1, step.current));

        var dimOpacity = 0.4 + 0.6 * step.current;
        step.bar.style.opacity = dimOpacity;
        step.title.style.opacity = dimOpacity;
        step.body.style.opacity = dimOpacity;

        var naturalHeight = step.body.scrollHeight || step.body.offsetHeight;
        step.body.style.maxHeight = (naturalHeight * step.current) + 'px';
        step.body.style.marginTop = (8 * step.current) + 'px';
      });

      this.raf = requestAnimationFrame(this.loop);
    }
  }

  if (!customElements.get('hbh-hiw-steps')) {
    customElements.define('hbh-hiw-steps', HbhHiwSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-hbh-main"] && !Shopify.designMode) return;
  try {
    
  class HbhMain extends HTMLElement {
    connectedCallback() {
      var root = this;

      if (!window.hbhReloadScrollFixed && window.performance && performance.getEntriesByType) {
        window.hbhReloadScrollFixed = true;
        var navEntry = performance.getEntriesByType('navigation')[0];
        if (navEntry && navEntry.type === 'reload') {
          if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
          window.scrollTo(0, 0);
        }
      }

      var slides = root.querySelectorAll('.hbh-gallery__slide');
      var thumbs = root.querySelectorAll('.hbh-gallery__thumb');
      var mainEl = root.querySelector('.hbh-gallery__main');
      var prevArrow = root.querySelector('.hbh-gallery__arrow--prev');
      var nextArrow = root.querySelector('.hbh-gallery__arrow--next');
      var mobileQuery = window.matchMedia('(max-width: 989px)');

      function setActiveClasses(index) {
        slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.slide === String(index)); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.slide === String(index)); });
      }

      function activate(index) {
        setActiveClasses(index);
        if (mobileQuery.matches && mainEl) {
          var target = mainEl.querySelector('.hbh-gallery__slide[data-slide="' + index + '"]');
          if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { activate(t.dataset.slide); });
      });

      function currentIndex() {
        var activeThumb = root.querySelector('.hbh-gallery__thumb.is-active') || root.querySelector('.hbh-gallery__slide.is-active');
        return parseInt(activeThumb ? activeThumb.dataset.slide : '0', 10) || 0;
      }

      function shiftSlide(dir) {
        var count = slides.length;
        if (!count) return;
        var next = (currentIndex() + dir + count) % count;
        activate(String(next));
      }

      if (prevArrow) prevArrow.addEventListener('click', function () { shiftSlide(-1); });
      if (nextArrow) nextArrow.addEventListener('click', function () { shiftSlide(1); });

      if (mainEl) {
        var scrollTimer;
        function syncFromScroll() {
          if (!mobileQuery.matches) return;
          var width = mainEl.clientWidth;
          if (!width) return;
          var idx = Math.round(mainEl.scrollLeft / width);
          setActiveClasses(idx);
        }
        mainEl.addEventListener('scroll', function () {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(syncFromScroll, 100);
        }, { passive: true });
        mainEl.addEventListener('scrollend', syncFromScroll, { passive: true });
      }

      /* Custom plan card ↔ RecurPay bridge.
         RecurPay injects a hidden widget with two radios (.recurpay__subscribe_radio /
         .recurpay__onetime_radio) that own the form's selling_plan + line-item props.
         Our visible card just mirrors the chosen option onto RecurPay's radio, so the
         real RecurPay selling_plan is attached (subscribe) or cleared (one-time) and a
         genuine subscription starts on Add to Cart. */
      var planChoiceInputs = root.querySelectorAll('input[name="hbh_plan_choice"]');
      var qtyInput = root.querySelector('[data-hbh-qty]');

      /* Subscribe = a 3-pack bundle (a Shopify automatic discount makes it buy-2-get-1-free),
         one-time = a single unit. Set the cart quantity to match the chosen option. */
      function setQty(plan) {
        if (qtyInput) {
          var subQty = qtyInput.getAttribute('data-sub-qty') || '3';
          qtyInput.value = plan === 'onetime' ? '1' : subQty;
        }
      }

      function findRecurRadio(plan) {
        return plan === 'onetime'
          ? root.querySelector('.recurpay__onetime_radio')
          : root.querySelector('.recurpay__subscribe_radio');
      }

      function syncToRecurPay(plan) {
        var radio = findRecurRadio(plan);
        if (!radio) return false;
        if (!radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          radio.dispatchEvent(new Event('click', { bubbles: true }));
        }
        return true;
      }

      planChoiceInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          if (input.checked) {
            setQty(input.dataset.plan);
            syncToRecurPay(input.dataset.plan);
          }
        });
      });

      /* RecurPay injects asynchronously — retry the initial sync until it exists. */
      (function initRecurSync() {
        var checked = root.querySelector('input[name="hbh_plan_choice"]:checked');
        var plan = checked ? checked.dataset.plan : 'subscribe';
        setQty(plan);
        var tries = 0;
        var iv = setInterval(function () {
          tries += 1;
          if (syncToRecurPay(plan) || tries > 40) clearInterval(iv);
        }, 250);
      })();

      var zoomBtn = root.querySelector('.hbh-gallery__zoom');
      var lightbox = root.querySelector('.hbh-gallery__lightbox');
      var lightboxImg = lightbox ? lightbox.querySelector('img') : null;
      var lightboxClose = root.querySelector('.hbh-gallery__lightbox-close');
      if (zoomBtn && lightbox && lightboxImg) {
        zoomBtn.addEventListener('click', function () {
          var active = root.querySelector('.hbh-gallery__slide.is-active');
          if (active && active.tagName === 'IMG') lightboxImg.src = active.src;
          lightbox.hidden = false;
        });
        lightboxClose.addEventListener('click', function () { lightbox.hidden = true; });
        lightbox.addEventListener('click', function (e) {
          if (e.target === lightbox) lightbox.hidden = true;
        });
      }

      var factsBtn = root.querySelector('.hbh-buybox__facts-trigger');
      var factsLightbox = root.querySelector('.hbh-buybox__facts-lightbox');
      var factsClose = root.querySelector('.hbh-buybox__facts-close');
      if (factsBtn && factsLightbox) {
        factsBtn.addEventListener('click', function () { factsLightbox.hidden = false; });
        if (factsClose) factsClose.addEventListener('click', function () { factsLightbox.hidden = true; });
        factsLightbox.addEventListener('click', function (e) {
          if (e.target === factsLightbox) factsLightbox.hidden = true;
        });
      }

      var atcAnchor = root.querySelector('[data-atc-anchor]');
      var stickybar = root.querySelector('hbh-stickybar');
      if (atcAnchor && stickybar) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            stickybar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        }, { threshold: 0 });
        observer.observe(atcAnchor);
      }

      var stickyAtc = root.querySelector('[data-sticky-atc]');
      if (stickyAtc && atcAnchor) {
        stickyAtc.addEventListener('click', function () {
          atcAnchor.click();
        });
      }
    }
  }

  if (!customElements.get('hbh-main')) {
    customElements.define('hbh-main', HbhMain);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-hbh-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var btn = document.querySelector('.hbh-rev__write-btn');
    if (btn && !btn.dataset.hbhWriteBound) {
      btn.dataset.hbhWriteBound = 'true';
      btn.addEventListener('click', function () {
        var footer = document.querySelector('footer, .hbh-ft') || document.body;
        var targetY = footer.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: targetY, behavior: 'smooth' });
        setTimeout(function () {
          if (Math.abs(window.scrollY - targetY) > 40) {
            window.scrollTo(0, targetY);
          }
        }, 600);
      });
    }

    var moreBtn = document.querySelector('.hbh-rev__more');
    var cards = document.querySelectorAll('.hbh-rev__card');
    if (moreBtn && cards.length && !moreBtn.dataset.hbhMoreBound) {
      moreBtn.dataset.hbhMoreBound = 'true';
      var maxBatch = 0;
      cards.forEach(function (c) {
        var b = parseInt(c.dataset.batch, 10) || 0;
        if (b > maxBatch) maxBatch = b;
      });
      var currentBatch = 0;
      if (maxBatch === 0) {
        moreBtn.hidden = true;
      }
      moreBtn.addEventListener('click', function () {
        currentBatch += 1;
        cards.forEach(function (c) {
          if (parseInt(c.dataset.batch, 10) === currentBatch) c.classList.remove('hbh-rev__card--hidden');
        });
        if (currentBatch >= maxBatch) moreBtn.hidden = true;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-hbh-survey"] && !Shopify.designMode) return;
  try {
    
  class HbhSurveyStats extends HTMLElement {
    connectedCallback() {
      var stats = this.querySelectorAll('.hbh-survey__stat');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var fill = el.querySelector('.hbh-survey__stat-fill');
          fill.style.setProperty('--target-width', fill.dataset.targetPercent + '%');
          el.classList.add('is-visible');
          var counter = el.querySelector('[data-count-to]');
          var target = parseInt(counter.dataset.countTo, 10);
          var start = null;
          var duration = 900;
          function step(ts) {
            if (!start) start = ts;
            var progress = Math.min((ts - start) / duration, 1);
            counter.textContent = Math.round(progress * target);
            if (progress < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
          observer.unobserve(el);
        });
      }, { threshold: 0.4 });
      stats.forEach(function (s) { observer.observe(s); });
    }
  }

  if (!customElements.get('hbh-survey-stats')) {
    customElements.define('hbh-survey-stats', HbhSurveyStats);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-newoffer123-main"] && !Shopify.designMode) return;
  try {
    
  class HbhMain extends HTMLElement {
    connectedCallback() {
      var root = this;

      if (!window.hbhReloadScrollFixed && window.performance && performance.getEntriesByType) {
        window.hbhReloadScrollFixed = true;
        var navEntry = performance.getEntriesByType('navigation')[0];
        if (navEntry && navEntry.type === 'reload') {
          if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
          window.scrollTo(0, 0);
        }
      }

      var slides = root.querySelectorAll('.hbh-gallery__slide');
      var thumbs = root.querySelectorAll('.hbh-gallery__thumb');
      var mainEl = root.querySelector('.hbh-gallery__main');
      var prevArrow = root.querySelector('.hbh-gallery__arrow--prev');
      var nextArrow = root.querySelector('.hbh-gallery__arrow--next');
      var mobileQuery = window.matchMedia('(max-width: 989px)');

      function setActiveClasses(index) {
        slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.slide === String(index)); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.slide === String(index)); });
      }

      function activate(index) {
        setActiveClasses(index);
        if (mobileQuery.matches && mainEl) {
          var target = mainEl.querySelector('.hbh-gallery__slide[data-slide="' + index + '"]');
          if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { activate(t.dataset.slide); });
      });

      function currentIndex() {
        var activeThumb = root.querySelector('.hbh-gallery__thumb.is-active') || root.querySelector('.hbh-gallery__slide.is-active');
        return parseInt(activeThumb ? activeThumb.dataset.slide : '0', 10) || 0;
      }

      function shiftSlide(dir) {
        var count = slides.length;
        if (!count) return;
        var next = (currentIndex() + dir + count) % count;
        activate(String(next));
      }

      if (prevArrow) prevArrow.addEventListener('click', function () { shiftSlide(-1); });
      if (nextArrow) nextArrow.addEventListener('click', function () { shiftSlide(1); });

      if (mainEl) {
        var scrollTimer;
        function syncFromScroll() {
          if (!mobileQuery.matches) return;
          var width = mainEl.clientWidth;
          if (!width) return;
          var idx = Math.round(mainEl.scrollLeft / width);
          setActiveClasses(idx);
        }
        mainEl.addEventListener('scroll', function () {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(syncFromScroll, 100);
        }, { passive: true });
        mainEl.addEventListener('scrollend', syncFromScroll, { passive: true });
      }

      /* Each card sets BOTH the variant id and the quantity that get added to cart from its
         data-hbh-variant / data-hbh-add-qty. BOGO card = 1-Pack variant x2; Buy 3 card = the
         3-Pack variant x1 — so a variant-targeted Shopify discount can apply to the 3-Pack. */
      var qtyInput = root.querySelector('[data-hbh-qty]');
      var idInput = root.querySelector('[data-hbh-id]');
      var bundleRadios = root.querySelectorAll('input[name="hbh_bundle"]');
      function syncBundleQty() {
        var checked = root.querySelector('input[name="hbh_bundle"]:checked');
        if (!checked) return;
        if (qtyInput) qtyInput.value = checked.getAttribute('data-hbh-add-qty') || '1';
        if (idInput) idInput.value = checked.getAttribute('data-hbh-variant') || idInput.value;
      }
      bundleRadios.forEach(function (r) { r.addEventListener('change', syncBundleQty); });
      syncBundleQty();

      var zoomBtn = root.querySelector('.hbh-gallery__zoom');
      var lightbox = root.querySelector('.hbh-gallery__lightbox');
      var lightboxImg = lightbox ? lightbox.querySelector('img') : null;
      var lightboxClose = root.querySelector('.hbh-gallery__lightbox-close');
      if (zoomBtn && lightbox && lightboxImg) {
        zoomBtn.addEventListener('click', function () {
          var active = root.querySelector('.hbh-gallery__slide.is-active');
          if (active && active.tagName === 'IMG') lightboxImg.src = active.src;
          lightbox.hidden = false;
        });
        lightboxClose.addEventListener('click', function () { lightbox.hidden = true; });
        lightbox.addEventListener('click', function (e) {
          if (e.target === lightbox) lightbox.hidden = true;
        });
      }

      var factsBtn = root.querySelector('.hbh-buybox__facts-trigger');
      var factsLightbox = root.querySelector('.hbh-buybox__facts-lightbox');
      var factsClose = root.querySelector('.hbh-buybox__facts-close');
      if (factsBtn && factsLightbox) {
        factsBtn.addEventListener('click', function () { factsLightbox.hidden = false; });
        if (factsClose) factsClose.addEventListener('click', function () { factsLightbox.hidden = true; });
        factsLightbox.addEventListener('click', function (e) {
          if (e.target === factsLightbox) factsLightbox.hidden = true;
        });
      }

      var atcAnchor = root.querySelector('[data-atc-anchor]');
      var stickybar = root.querySelector('hbh-stickybar');
      if (atcAnchor && stickybar) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            stickybar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        }, { threshold: 0 });
        observer.observe(atcAnchor);
      }

      var stickyAtc = root.querySelector('[data-sticky-atc]');
      if (stickyAtc && atcAnchor) {
        stickyAtc.addEventListener('click', function () {
          atcAnchor.click();
        });
      }
    }
  }

  if (!customElements.get('no123-main')) {
    customElements.define('no123-main', HbhMain);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-pmdd-community"] && !Shopify.designMode) return;
  try {
    
  class HlRevealGroup extends HTMLElement {
    connectedCallback() {
      var items = this.querySelectorAll('.hl-reveal');
      if (!items.length) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
      items.forEach(function (item) {
        observer.observe(item);
      });
    }
  }

  if (!customElements.get('hl-reveal-group')) {
    customElements.define('hl-reveal-group', HlRevealGroup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-pmdd-fullreviews"] && !Shopify.designMode) return;
  try {
    
  class HlRevealGroup extends HTMLElement {
    connectedCallback() {
      var items = this.querySelectorAll('.hl-reveal');
      if (!items.length) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
      items.forEach(function (item) {
        observer.observe(item);
      });
    }
  }

  if (!customElements.get('hl-reveal-group')) {
    customElements.define('hl-reveal-group', HlRevealGroup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-pmdd-hellweek"] && !Shopify.designMode) return;
  try {
    
  class HlRevealGroup extends HTMLElement {
    connectedCallback() {
      var items = this.querySelectorAll('.hl-reveal');
      if (!items.length) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
      items.forEach(function (item) {
        observer.observe(item);
      });
    }
  }

  if (!customElements.get('hl-reveal-group')) {
    customElements.define('hl-reveal-group', HlRevealGroup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-pmdd-quality"] && !Shopify.designMode) return;
  try {
    
  class HlRevealGroup extends HTMLElement {
    connectedCallback() {
      var items = this.querySelectorAll('.hl-reveal');
      if (!items.length) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
      items.forEach(function (item) {
        observer.observe(item);
      });
    }
  }

  if (!customElements.get('hl-reveal-group')) {
    customElements.define('hl-reveal-group', HlRevealGroup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-pmdd-reviewstrip"] && !Shopify.designMode) return;
  try {
    
  class HlMarquee extends HTMLElement {
    connectedCallback() {
      this.originals = Array.from(this.children);
      if (!this.originals.length) return;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.build();
      this.resizeObserver = new ResizeObserver(() => this.debounceBuild());
      this.resizeObserver.observe(this.closest('.hl-rs__viewport'));
      this.setupTouchHold();
    }

    setupTouchHold() {
      // Touch devices have no real hover, so the `:hover` pause (gated to
      // `@media (hover: hover)` in CSS, deliberately excluding touch-only
      // devices) never applies here — some mobile browsers otherwise get
      // stuck in a simulated `:hover` state after a tap with no mouse to
      // ever "unhover" it, permanently pausing the scroll. A real
      // press-and-hold should still pause it though: touchstart pauses,
      // but touchmove (the finger is actually scrolling the page, not
      // holding still) resumes it immediately so a normal scroll-past
      // barely interrupts the animation.
      const pause = () => this.classList.add('is-touch-paused');
      const resume = () => this.classList.remove('is-touch-paused');
      this.addEventListener('touchstart', pause, { passive: true });
      this.addEventListener('touchmove', resume, { passive: true });
      this.addEventListener('touchend', resume, { passive: true });
      this.addEventListener('touchcancel', resume, { passive: true });
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
    }

    debounceBuild() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.build(), 150);
    }

    build() {
      // Reset to just the original, non-cloned tiles before recomputing.
      this.innerHTML = '';
      this.originals.forEach((el) => this.appendChild(el.cloneNode(true)));
      this.classList.remove('hl-rs__track--animating');
      this.style.removeProperty('--hl-rs-distance');
      this.style.removeProperty('animation-duration');

      const viewport = this.closest('.hl-rs__viewport');
      if (!viewport || this.reduceMotion) return;

      const targetWidth = viewport.offsetWidth * 2;
      let guard = 0;
      // Always append at least one extra full set: if the original tiles
      // alone already exceed targetWidth (narrow viewport, few tiles, or
      // just wide tiles), the width check below never becomes true and
      // this loop used to never run at all — leaving only one set of
      // tiles with no "repeat" set to loop back into. `children[originals
      // .length]` (firstRepeatChild) would then be undefined and build()
      // returned early without ever activating the scroll animation.
      do {
        this.originals.forEach((el) => this.appendChild(el.cloneNode(true)));
        guard += 1;
      } while (this.scrollWidth < targetWidth && guard < 20);

      const firstRepeatChild = this.children[this.originals.length];
      if (!firstRepeatChild) return;

      const distance = firstRepeatChild.offsetLeft - this.children[0].offsetLeft;
      if (!distance) return;

      const pxPerSecond = 46;
      const duration = distance / pxPerSecond;

      this.style.setProperty('--hl-rs-distance', `-${distance}px`);
      this.style.animationDuration = `${duration}s`;
      this.classList.add('hl-rs__track--animating');

      Array.from(this.children)
        .slice(this.originals.length)
        .forEach((el) => el.setAttribute('aria-hidden', 'true'));
    }
  }

  if (!customElements.get('hl-marquee')) {
    customElements.define('hl-marquee', HlMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-pmdd-socialproof"] && !Shopify.designMode) return;
  try {
    
  class HlRevealGroup extends HTMLElement {
    connectedCallback() {
      var items = this.querySelectorAll('.hl-reveal');
      if (!items.length) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
      items.forEach(function (item) {
        observer.observe(item);
      });
    }
  }

  if (!customElements.get('hl-reveal-group')) {
    customElements.define('hl-reveal-group', HlRevealGroup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-pmdd-whyitworks"] && !Shopify.designMode) return;
  try {
    
  class HlRevealGroup extends HTMLElement {
    connectedCallback() {
      var items = this.querySelectorAll('.hl-reveal');
      if (!items.length) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
      items.forEach(function (item) {
        observer.observe(item);
      });
    }
  }

  if (!customElements.get('hl-reveal-group')) {
    customElements.define('hl-reveal-group', HlRevealGroup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-v2-reviewgallery"] && !Shopify.designMode) return;
  try {
    
  class HlV2Marquee extends HTMLElement {
    connectedCallback() {
      this.originals = Array.from(this.children);
      if (!this.originals.length) return;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.build();
      this.resizeObserver = new ResizeObserver(() => this.debounceBuild());
      this.resizeObserver.observe(this.closest('.hl-rg__viewport'));
      this.setupTouchHold();
    }

    setupTouchHold() {
      // Touch devices have no real hover, so the `:hover` pause (gated to
      // `@media (hover: hover)` in CSS, deliberately excluding touch-only
      // devices) never applies here — some mobile browsers otherwise get
      // stuck in a simulated `:hover` state after a tap with no mouse to
      // ever "unhover" it, permanently pausing the scroll. A real
      // press-and-hold should still pause it though: touchstart pauses,
      // but touchmove (the finger is actually scrolling the page, not
      // holding still) resumes it immediately so a normal scroll-past
      // barely interrupts the animation.
      const pause = () => this.classList.add('is-touch-paused');
      const resume = () => this.classList.remove('is-touch-paused');
      this.addEventListener('touchstart', pause, { passive: true });
      this.addEventListener('touchmove', resume, { passive: true });
      this.addEventListener('touchend', resume, { passive: true });
      this.addEventListener('touchcancel', resume, { passive: true });
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
    }

    debounceBuild() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.build(), 150);
    }

    build() {
      this.innerHTML = '';
      this.originals.forEach((el) => this.appendChild(el.cloneNode(true)));
      this.classList.remove('hl-rg__track--animating');
      this.style.removeProperty('--hl-rg-distance');
      this.style.removeProperty('animation-duration');

      const viewport = this.closest('.hl-rg__viewport');
      if (!viewport || this.reduceMotion) return;

      const targetWidth = viewport.offsetWidth * 2;
      let guard = 0;
      // Always append at least one extra full set: if the original tiles
      // alone already exceed targetWidth (narrow viewport, few tiles, or
      // just wide tiles), the width check below never becomes true and
      // this loop used to never run at all — leaving only one set of
      // tiles with no "repeat" set to loop back into. `children[originals
      // .length]` (firstRepeatChild) would then be undefined and build()
      // returned early without ever activating the scroll animation.
      do {
        this.originals.forEach((el) => this.appendChild(el.cloneNode(true)));
        guard += 1;
      } while (this.scrollWidth < targetWidth && guard < 20);

      const firstRepeatChild = this.children[this.originals.length];
      if (!firstRepeatChild) return;

      const distance = firstRepeatChild.offsetLeft - this.children[0].offsetLeft;
      if (!distance) return;

      const pxPerSecond = 42;
      const duration = distance / pxPerSecond;

      this.style.setProperty('--hl-rg-distance', `-${distance}px`);
      this.style.animationDuration = `${duration}s`;
      this.classList.add('hl-rg__track--animating');

      Array.from(this.children)
        .slice(this.originals.length)
        .forEach((el) => el.setAttribute('aria-hidden', 'true'));
    }
  }

  if (!customElements.get('hl-v2-marquee')) {
    customElements.define('hl-v2-marquee', HlV2Marquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-v2-sciencestats"] && !Shopify.designMode) return;
  try {
    
  function hlSciAnimateCard(cardEl) {
    var percentEl = cardEl.querySelector('.hl-sci__percent');
    var target = percentEl ? parseInt(percentEl.dataset.target, 10) || 0 : 0;
    var duration = 1200;
    var start = null;

    if (percentEl) {
      function countStep(timestamp) {
        if (!start) start = timestamp;
        var elapsed = timestamp - start;
        var progress = Math.min(elapsed / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = Math.round(target * eased);
        percentEl.childNodes[0].nodeValue = value;
        if (progress < 1) {
          window.requestAnimationFrame(countStep);
        } else {
          percentEl.childNodes[0].nodeValue = target;
        }
      }
      window.requestAnimationFrame(countStep);
    }

    var trialCol = cardEl.querySelector('.hl-sci__trial-col[data-target]');
    if (trialCol) {
      var trialPct = parseInt(trialCol.dataset.target, 10) || 0;
      var colWrap = trialCol.closest('.hl-sci__trial-col-wrap');
      var valueEl = colWrap ? colWrap.querySelector('.hl-sci__trial-value') : null;

      window.requestAnimationFrame(function () {
        trialCol.style.height = trialPct + '%';
      });

      if (valueEl) {
        var vStart = null;
        function trialValueStep(timestamp) {
          if (!vStart) vStart = timestamp;
          var elapsed = timestamp - vStart;
          var progress = Math.min(elapsed / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          valueEl.textContent = Math.round(trialPct * eased) + '%';
          if (progress < 1) {
            window.requestAnimationFrame(trialValueStep);
          } else {
            valueEl.textContent = trialPct + '%';
          }
        }
        window.requestAnimationFrame(trialValueStep);
      }
    }

    var donutRing = cardEl.querySelector('.hl-sci__donut-ring');
    if (donutRing) {
      var ringPct = parseInt(donutRing.dataset.target, 10) || 0;
      var dpct = ringPct;
      var rStart = null;
      function ringStep(timestamp) {
        if (!rStart) rStart = timestamp;
        var elapsed = timestamp - rStart;
        var progress = Math.min(elapsed / duration, 1);
        // Linear, not eased: an ease-out curve finishes ~99% of the sweep
        // in the first tenth of the duration, so the ring visually "pops"
        // to its final position almost instantly instead of showing a
        // perceivable spin from 12 o'clock round to its target angle.
        donutRing.style.setProperty('--pct', ringPct * progress);
        if (progress < 1) {
          window.requestAnimationFrame(ringStep);
        } else {
          donutRing.style.setProperty('--pct', ringPct);
        }
      }
      window.requestAnimationFrame(ringStep);
      var donutValue = cardEl.querySelector('.hl-sci__donut-value');
      if (donutValue) {
        var dStart = null;
        function donutStep(timestamp) {
          if (!dStart) dStart = timestamp;
          var elapsed = timestamp - dStart;
          var progress = Math.min(elapsed / duration, 1);
          donutValue.textContent = Math.round(dpct * progress) + '%';
          if (progress < 1) {
            window.requestAnimationFrame(donutStep);
          } else {
            donutValue.textContent = dpct + '%';
          }
        }
        window.requestAnimationFrame(donutStep);
      }
    }
  }

  class HlSciRevealGroup extends HTMLElement {
    connectedCallback() {
      var toggleBtns = this.querySelectorAll('.hl-sci__chart-toggle-btn');
      toggleBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = btn.closest('.hl-sci__card');
          var isOpen = card.classList.toggle('hl-sci__card--chart-open');
          btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      });

      var items = this.querySelectorAll('.hl-sci-reveal');
      if (!items.length) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            if (entry.target.classList.contains('hl-sci__card')) {
              hlSciAnimateCard(entry.target);
            }
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -60px 0px' });
      items.forEach(function (item) {
        observer.observe(item);
      });
    }
  }

  if (!customElements.get('hl-sci-reveal-group')) {
    customElements.define('hl-sci-reveal-group', HlSciRevealGroup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-v2-whatsinside"] && !Shopify.designMode) return;
  try {
    
  var HL_WI_SLOT_LINE_HEIGHT = 16;

  function hlWiBuildSlotDigits(slotEl, targetStr) {
    slotEl.innerHTML = '';
    var reels = [];

    targetStr.split('').forEach(function (ch, index) {
      var finalDigit = parseInt(ch, 10);
      var cell = document.createElement('span');
      cell.className = 'hl-wi__slot-cell';
      var strip = document.createElement('span');
      strip.className = 'hl-wi__slot-strip';

      var cycles = 2 + index;
      var sequence = [];
      for (var c = 0; c < cycles; c++) {
        for (var d = 0; d <= 9; d++) sequence.push(d);
      }
      sequence.push(finalDigit);

      sequence.forEach(function (digit) {
        var line = document.createElement('span');
        line.className = 'hl-wi__slot-digit';
        line.textContent = digit;
        strip.appendChild(line);
      });

      cell.appendChild(strip);
      slotEl.appendChild(cell);
      reels.push({ strip: strip, finalIndex: sequence.length - 1 });
    });

    return reels;
  }

  function hlWiAnimateMeter(meterEl) {
    var target = parseInt(meterEl.dataset.target, 10) || 0;
    var percent = Math.max(0, Math.min(100, parseInt(meterEl.dataset.percent, 10) || 0));
    var trackEl = meterEl.querySelector('.hl-wi__meter-track');
    var fillEl = meterEl.querySelector('.hl-wi__meter-fill');
    var slotEl = meterEl.querySelector('.hl-wi__meter-slot');
    var circumference = 169.6;
    var POP_IN_DELAY = 450;

    meterEl.classList.add('is-active');

    if (trackEl) {
      trackEl.style.transition = 'none';
      trackEl.style.strokeDashoffset = circumference;
    }
    if (fillEl) {
      fillEl.style.transition = 'none';
      fillEl.style.strokeDashoffset = circumference;
    }
    if (trackEl) trackEl.getBoundingClientRect();

    window.setTimeout(function () {
      if (trackEl) {
        trackEl.style.transition = 'stroke-dashoffset 0.7s cubic-bezier(0.16, 1, 0.3, 1)';
        window.requestAnimationFrame(function () {
          trackEl.style.strokeDashoffset = 0;
        });
      }

      if (fillEl) {
        var offset = circumference - (circumference * percent / 100);
        fillEl.style.transition = 'stroke-dashoffset 1.1s cubic-bezier(0.16, 1, 0.3, 1)';
        window.requestAnimationFrame(function () {
          fillEl.style.strokeDashoffset = offset;
        });
      }

      if (!slotEl) return;
      var reels = hlWiBuildSlotDigits(slotEl, String(target));

      reels.forEach(function (reel, index) {
        reel.strip.style.transition = 'none';
        reel.strip.style.transform = 'translateY(0)';
        reel.strip.getBoundingClientRect();
        var delay = index * 70;
        var duration = 900 + index * 180;
        window.setTimeout(function () {
          reel.strip.style.transition = 'transform ' + duration + 'ms cubic-bezier(0.16, 1, 0.3, 1)';
          reel.strip.style.transform = 'translateY(-' + (reel.finalIndex * HL_WI_SLOT_LINE_HEIGHT) + 'px)';
        }, delay);
      });
    }, POP_IN_DELAY);
  }

  class HlRevealGroup extends HTMLElement {
    connectedCallback() {
      var items = this.querySelectorAll('.hl-reveal');
      if (!items.length) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            var meter = entry.target.querySelector('.hl-wi__meter');
            if (meter) hlWiAnimateMeter(meter);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
      items.forEach(function (item) {
        observer.observe(item);
      });
    }
  }

  if (!customElements.get('hl-wi-reveal-group')) {
    customElements.define('hl-wi-reveal-group', HlRevealGroup);
  }

  } catch(e) { console.error(e); }
})();
})();
